import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { faMegaphoneShout } from '@epicuro-next/ataraxia/icons';
import { IMAGE_MAX_SIZES } from '@epicuro-next/ataraxia/image';
import {
  MediaObjectFit,
  MediaObjectPosition,
} from '@epicuro-next/ataraxia/models';
import {
  mapMessage,
  MessagePosition,
  SnackBarService,
} from '@epicuro-next/ataraxia/snack-bar';
import { IListAnalyticsExchange } from '@epicuro-next/data/reporting-api';
import { plural } from '@epicuro-next/platform/i18n';
import { BehaviorSubject } from 'rxjs';

import { copyEmailFailedText, copyEmailSuccessText } from '../../data';
import { BestPerformingList } from '../../models';

@Component({
  selector: 'epc-dashboard-table',
  templateUrl: './dashboard-table.component.html',
  styleUrls: ['./dashboard-table.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class DashboardTableComponent {
  @Input()
  public bestLists: BestPerformingList[];

  @Input()
  public currentUserExternalId: string;

  @Input()
  public isLoading: boolean;

  @Input()
  public exchange: IListAnalyticsExchange;

  @Input()
  public showHotIconBadges: boolean;

  @Output()
  public listSelect = new EventEmitter<string>();

  public shouldMediaPlay$$ = new BehaviorSubject(false);

  public copyEmailText = $localize`:AnalyticsDashboard|Analytics Dashboard Copy Email text@@analyticsDashboardCopyEmailText:Copy email`;

  public skeletons = new Array(4);
  public imageMaxSizes = IMAGE_MAX_SIZES;
  public megaphoneShout = faMegaphoneShout;
  public objectFit = MediaObjectFit;
  public mediaObjectPosition = MediaObjectPosition;
  public baseTextWidthSize = '7rem';
  public baseTextHeightSize = '1rem';

  public baseIconWidthSize = '1rem';
  public baseIconHeightSize = '0.875rem';

  public promotedViaSpotlightText = $localize`:AnalyticsDashboard|Analytics Dashboard Promoted via spotlight text@@analyticsDashboardPromotedViaSpotlightText:Promoted via Spotlight`;

  constructor(private snackBarService: SnackBarService) {}

  public getSharedViaEmailText(count: number) {
    return plural<number>(
      count,
      {
        1: $localize`:AnalyticsDashboard|Analytics Dashboard Shared via Email text@@analyticsDashboardDashboardSharedViaEmailText:Shared via email to ${count} recipient`,
      },
      $localize`:AnalyticsDashboard|Analytics Dashboard Shared via Email text@@analyticsDashboardDashboardSharedViaEmailText:Shared via email to ${count} recipients`,
    );
  }

  public copyToClipboard(success: boolean) {
    const messageData = mapMessage(
      success,
      copyEmailSuccessText,
      copyEmailFailedText,
    );

    this.snackBarService.show(
      messageData.msg,
      MessagePosition.BOTTOM,
      messageData.msgType,
    );
  }

  public redirectToList(listId: string) {
    this.listSelect.emit(listId);
  }
}
